import { useMemo } from "react";

import { applyGridFilter } from "../../utils/filter/grid-filter";

import type { GridColDef } from "@mui/x-data-grid";
import type ListFilter from "../../types/ListFilter";

// Rows that pass every active filter. A filter reads its value through the
// column named by its field (or source_field), so it matches what the grid shows.
export const useFilteredRows = <Row>(
  rows: Row[],
  columns: GridColDef[],
  activeFilters: ListFilter[]
): Row[] => {
  const columnFieldMap = useMemo(
    () =>
      columns.reduce((cMap, c) => {
        cMap[c.field] = c;
        return cMap;
      }, {} as Record<string, GridColDef>),
    [columns]
  );

  return useMemo(
    () =>
      activeFilters.length > 0
        ? activeFilters.reduce(
            (data, filter) => applyGridFilter(data, filter, columnFieldMap),
            rows
          )
        : rows,
    [rows, activeFilters, columnFieldMap]
  );
};
